import createBrowserHistory from 'history/lib/createBrowserHistory';
import useQueries from 'history/lib/useQueries';
import qs from 'qs';
import cleanQuery from 'lib/cleanQuery';
import omit from 'ramda/src/omit';
import compose from 'lib/compose';
import same from 'lib/same';

function alphabeticalSort(a: string, b: string) {
  return a.localeCompare(b);
}

const stringifyQuery = (query) =>
  qs.stringify(cleanQuery(query, { skipNulls: true, sort: alphabeticalSort }));

function createRouterHistory(createHistory) {
  let func = compose(useQueries)(createHistory);

  let history = func({
    parseQueryString: (queryString) =>
      qs.parse(queryString, { arrayLimit: 100 }),
    stringifyQuery,
  });

  history.getQuery = () => history.getCurrentLocation().query || {};

  history.getKey = (key: string) => history.getQuery()[key];
  history.stringifyQuery = stringifyQuery;

  history.updateQuery = (o: Object) => {
    const query = history.getQuery();
    const newQuery = cleanQuery(o);
    if (!same(query, newQuery)) {
      history.replace({
        ...history.getCurrentLocation(),
        query: newQuery,
      });
    }
  };

  history.updateKey = (key: string, value: any) => {
    let newValue = value;
    const query = history.getQuery();
    if (typeof value === 'function') {
      newValue = value(query[key]);
    }
    history.updateQuery({ ...query, [key]: newValue });
  };

  history.deleteKey = (key: string) => {
    const o = omit([key])(history.getQuery());
    history.updateQuery(o);
  };

  // TODO: test
  history.getAppBase = () => {
    const { protocol, host } = window.location;
    return `${protocol}//${host}`;
  };

  return history;
}

export default createRouterHistory(createBrowserHistory);
